import api from "../utils/api";

export const getClientProfileSettings = async (username) => {
  try {
    const response = await api.get(`/client_profile_settings?username=${encodeURIComponent(username)}`);
    return response.data;
  } catch (error) {
    console.error("Get client profile settings error:", error);
    throw error;
  }
};

export const updateClientProfileSettings = async (username, data) => {
  try {
    const response = await api.post("/client_profile_settings", { username, ...data });
    return response.data;
  } catch (error) {
    console.error("Update client profile settings error:", error);
    throw error;
  }
};

export const getClientMachines = async (username) => {
  try {
    const response = await api.get(`/client-machines?username=${username}`);
    return response.data;
  } catch (error) {
    console.error("Get client machines error:", error);
    throw error;
  }
};

export const updateMachineConfig = async (meterId, config) => {
  try {
    const response = await api.patch(`/client-machines/${meterId}`, config);
    return response.data;
  } catch (error) {
    console.error("Update machine config error:", error);
    throw error;
  }
};

export const getCustomMachines = async (username) => {
  try {
    const response = await api.get(`/get_custom_machines?username=${username}`);
    return response.data;
  } catch (error) {
    console.error("Get custom machines error:", error);
    throw error;
  }
};

export const postCustomMachines = async (username, machines) => {
  try {
    const response = await api.post(`/post_custom_machines`, {
      username,
      machines,
    });
    return response.data;
  } catch (error) {
    console.error("Post custom machines error:", error);
    throw error;
  }
};

export const getClientEmails = async (username) => {
  try {
    const response = await api.get(
      `/client_emails?username=${encodeURIComponent(username)}`,
    );
    return response.data?.emails || [];
  } catch (error) {
    console.error("Get client emails error:", error);
    throw error;
  }
};

export const getMachineAlertEmails = async (meterId, machineName) => {
  try {
    const response = await api.get(`/machine_alert_emails`, {
      params: { meter_id: meterId, machine_name: machineName },
    });
    return response.data?.emails || [];
  } catch (error) {
    console.error("Get machine alert emails error:", error);
    throw error;
  }
};

export const setMachineAlertEmails = async (meterId, machineName, emails) => {
  try {
    const response = await api.post(`/machine_alert_emails`, {
      meter_id: meterId,
      machine_name: machineName,
      emails,
    });
    return response.data?.emails || emails;
  } catch (error) {
    console.error("Set machine alert emails error:", error);
    throw error;
  }
};
